var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsightsicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7002 7.27195C3.7002 4.97051 5.57697 3.10483 7.8921 3.10483H38.6327C40.9478 3.10483 42.8246 4.97051 42.8246 7.27195C42.8246 9.57339 40.9478 11.4391 38.6327 11.4391H7.8921C5.57697 11.4391 3.7002 9.57339 3.7002 7.27195ZM7.8921 5.88291C7.12039 5.88291 6.4948 6.5048 6.4948 7.27195C6.4948 8.03909 7.12039 8.66099 7.8921 8.66099H38.6327C39.4044 8.66099 40.03 8.03909 40.03 7.27195C40.03 6.5048 39.4044 5.88291 38.6327 5.88291H7.8921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7002 29.4966C3.7002 27.1952 5.57697 25.3295 7.8921 25.3295H38.6327C40.9478 25.3295 42.8246 27.1952 42.8246 29.4966C42.8246 31.798 40.9478 33.6637 38.6327 33.6637H7.8921C5.57697 33.6637 3.7002 31.798 3.7002 29.4966ZM7.8921 28.1076C7.12039 28.1076 6.4948 28.7295 6.4948 29.4966C6.4948 30.2637 7.12039 30.8856 7.8921 30.8856H38.6327C39.4044 30.8856 40.03 30.2637 40.03 29.4966C40.03 28.7295 39.4044 28.1076 38.6327 28.1076H7.8921Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49512 10.05C6.49512 9.28289 7.12071 8.661 7.89242 8.661H38.633C39.4047 8.661 40.0303 9.28289 40.0303 10.05V26.7185C40.0303 27.4857 39.4047 28.1076 38.633 28.1076H7.89242C7.12071 28.1076 6.49512 27.4857 6.49512 26.7185V10.05ZM9.28972 11.4391V25.3295H37.2357V11.4391H9.28972Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2628 30.8856C23.7117 30.8856 24.1332 31.1 24.3959 31.4618L30.4464 39.796C30.898 40.4181 30.7568 41.2863 30.131 41.7353C29.5053 42.1842 28.6319 42.0439 28.1803 41.4218L23.2628 34.6483L18.3454 41.4218C17.8938 42.0439 17.0204 42.1842 16.3946 41.7353C15.7689 41.2863 15.6277 40.4181 16.0793 39.796L22.1298 31.4618C22.3925 31.1 22.814 30.8856 23.2628 30.8856Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0737 13.2785C34.5952 13.8441 34.5567 14.7227 33.9879 15.2411L25.6041 22.8808C25.1174 23.3243 24.3849 23.3686 23.8477 22.9872L19.8477 20.1469L15.7881 23.606C15.2022 24.1053 14.3201 24.0378 13.8179 23.4554C13.3156 22.8729 13.3835 21.996 13.9694 21.4968L18.86 17.3296C19.348 16.9138 20.0584 16.8826 20.5815 17.254L24.5505 20.0722L32.0995 13.1932C32.6683 12.6748 33.5522 12.713 34.0737 13.2785Z",
    fill: "#9EC6E5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsightsicon);
export default __webpack_public_path__ + "static/media/insightsicon.fcf04b7c04c3b53eeb3ccddffb952eaf.svg";
export { ForwardRef as ReactComponent };